module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.28006",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.4393",
      "atom": "static-1.4759",
      "conversations-async-data": "static-2.7349",
      "conversations-error-reporting": "static-1.8564",
      "conversations-internal-pub-sub": "static-1.15652",
      "conversations-internal-schema": "static-1.12314",
      "conversations-message-history": "static-1.11695",
      "conversations-test-sdk": "static-1.10184",
      "conversations-visitor-experience-components": "static-1.21369",
      "head-dlb": "static-1.4702",
      "hs-promise-utils": "static-1.5278",
      "hs-test-utils": "static-1.7667",
      "hubspot-dlb": "static-2.1773",
      "HubStyleTokens": "static-2.11109",
      "I18n": "static-7.1538",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2704",
      "jasmine-runner": "static-1.6139",
      "quartz": "static-1.6568",
      "react-dlb": "static-1.69",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.58",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4162",
      "StyleGuideUI": "static-3.481",
      "transmute": "static-2.77",
      "urlinator": "static-1.4221",
      "usage-tracker": "static-1.7023",
      "usage-tracker-core": "static-1.6873",
      "usage-tracker-public": "static-1.6834",
      "viral-links-lib": "static-1.6707",
      "visitor-ui-component-library": "static-1.5814",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4471",
      "conversations-prop-types": "static-1.7138",
      "conversations-visitor-message-history": "static-1.20106",
      "cssUtils": "static-1.694",
      "enviro": "static-4.371",
      "flux-actions": "static-1.295",
      "foundations-components": "static-1.7281",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5872",
      "hubspot-url-utils": "static-1.3825",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9296",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.334",
      "raven": "static-3.5564",
      "react": "static-7.175",
      "react-aria": "static-1.59",
      "react-dom": "static-7.85",
      "react-redux": "static-7.65",
      "react-rhumb": "static-1.16318",
      "react-utils": "static-2.5072",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.7828",
      "signup-constants": "static-1.18185",
      "styled-components": "static-2.83",
      "usage-tracker-multi": "static-1.5437",
      "visitor-ui-component-library-icons": "static-1.5625",
      "hs-promise-rejection-tracking": "static-1.5234",
      "raven-hubspot": "static-1.5871",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3122",
      "moment": "static-3.26",
      "quartz-config": "static-1.346",
      "quartz-core": "static-1.5787",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4517",
      "foundations-theming": "static-1.4088",
      "UIComponents": "static-3.8056",
      "cv-backend-services": "static-1.1446",
      "immutable-less": "static-1.4341",
      "conversations-skeleton-state": "static-1.6938",
      "crm-events-viz-core": "static-1.32067",
      "customer-agent-discovery-components-lib": "static-1.2150",
      "customer-data-objects": "static-1.7298",
      "data-fetching-client": "static-1.9361",
      "icons": "static-2.611",
      "react-input-autosize": "static-2.17",
      "react-router-dom": "static-5.26",
      "rpc-client-utils": "static-1.4291",
      "tanstack-virtual": "static-1.23",
      "ui-images": "static-2.1056",
      "HeadJS": "static-2.687",
      "framer-motion": "static-1.64",
      "hs-test-utils-bend-plugin": "static-1.2778",
      "msw": "static-1.39",
      "testing-library": "static-1.145",
      "i18n-data": "static-1.214",
      "moment-timezone": "static-5.76",
      "jasmine": "static-4.4017",
      "history": "static-4.47",
      "signup-ui-url-generator": "static-2.7717",
      "HubStyle": "static-2.11417",
      "quartz-i18n": "static-1.243",
      "sassPrefix": "static-1.149",
      "bend-plugin-foundations-components": "static-1.3550",
      "floating-ui": "static-1.49",
      "foundations-theming-specialty": "static-1.1804",
      "hs-story-utils": "static-1.9115",
      "react-virtualized": "static-2.92",
      "tanstack-table": "static-1.48",
      "trellis-assets": "static-1.960",
      "ui-fonts": "static-1.371",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3624",
      "usage-tracker-anonymous": "static-1.5440",
      "bender-build-tools": "static-1.2798",
      "dispatcher": "static-1.129",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.767",
      "hubspotter-http": "static-1.4374",
      "mobile-manifest-mixins": "static-1.460",
      "quartz-auth": "static-1.243",
      "quartz-head": "static-1.233",
      "quartz-test": "static-1.243",
      "usage-tracker-container": "static-1.7013",
      "bend-plugin-foundations-theming": "static-1.2571",
      "foundations-theming-base": "static-1.3073",
      "stylex": "static-1.25",
      "ts-schema": "static-1.3800",
      "apollo-stack-hubspot": "static-3.79",
      "avatar-components": "static-1.2151",
      "content-assistance-lib": "static-1.7287",
      "crm-component-utils": "static-1.38190",
      "crm-display-components": "static-1.23940",
      "crm-fe-perf": "static-1.22568",
      "crm-links": "static-1.5939",
      "crm-message-bus": "static-1.42060",
      "crm-search-service-types": "static-1.854",
      "crm-source-interpretation-lib": "static-1.5018",
      "customer-data-communicator": "static-1.44596",
      "customer-data-email": "static-1.17490",
      "customer-data-filters-ui": "static-1.38486",
      "customer-data-objects-ui-components": "static-1.12689",
      "customer-data-properties": "static-1.50455",
      "customer-data-rte": "static-1.32206",
      "customer-data-ui-utilities": "static-1.9513",
      "draft-plugins": "static-2.21111",
      "file-manager-components": "static-1.22566",
      "FileManagerCore": "static-1.38065",
      "framework-data-schema-resolvers": "static-1.6552",
      "frontend-preferences-client": "static-1.7611",
      "hubspot-apollo-client": "static-1.4568",
      "hubspot-prosemirror": "static-1.17305",
      "object-comments-thread-lib": "static-1.9823",
      "reference-resolvers-lite": "static-1.7778",
      "ui-addon-upgrades": "static-9.17400",
      "universal-associations-select": "static-1.10650",
      "ai-components-ui-library": "static-1.8062",
      "final-form": "static-1.63",
      "inbound-db-properties-service-client": "static-1.3574",
      "property-translator": "static-1.5100",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.75",
      "hub-http-shared-msw-handlers": "static-1.9187",
      "hubspotter-http-shared-msw-handlers": "static-1.9185",
      "superstore": "static-1.4460",
      "ui-addon-video-player": "static-1.8408",
      "ui-coaching-tips": "static-1.27637",
      "card-properties-lib": "static-1.43210",
      "crm-actions": "static-1.5958",
      "crm-cards-data": "static-1.1050",
      "crm-cards-sdk": "static-1.42581",
      "customer-data-properties-shared-msw-handlers": "static-1.8514",
      "customer-data-property-utils": "static-1.7755",
      "customer-data-tracking": "static-1.6548",
      "framework-data-table": "static-2.11169",
      "location-customization-utils-lib": "static-1.8202",
      "calling-error-reporting": "static-1.30982",
      "calling-internal-common": "static-1.30976",
      "calling-usage-tracker": "static-1.6226",
      "crm_data": "static-4.90876",
      "crm_schema": "static-3.90915",
      "customer-data-content": "static-1.26648",
      "draft-content-plugins": "static-1.27476",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.23463",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.23275",
      "EmailSignatureEditor": "static-1.23725",
      "FileManagerLib": "static-1.38206",
      "hubspot-prosemirror-plugins": "static-1.17297",
      "integration-settings-components": "static-1.14452",
      "integrations-lib": "static-1.15056",
      "integrations-tracking-lib": "static-1.5271",
      "native-integrations-shared-strings": "static-1.7474",
      "nav-meta": "static-1.28583",
      "onboarding-scopes": "static-1.6130",
      "outreach-assistant-email-generation": "static-1.5573",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.36811",
      "react-colorpicker": "static-2.9900",
      "react-dnd-compat": "static-1.4311",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7846",
      "rich-text-lib": "static-1.19271",
      "sales-email-signature-service-client": "static-1.3528",
      "sequences-lib": "static-1.7519",
      "timezone-utils": "static-2.4932",
      "ui-addon-i18n": "static-1.10813",
      "ui-addon-iframeable": "static-1.8703",
      "ui-business-units-lib": "static-1.8707",
      "ui-gdpr-components": "static-1.10033",
      "ui-shepherd-react": "static-3.9829",
      "user-context": "static-1.4781",
      "whatsapp-sending-lib": "static-1.4592",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4336",
      "salesImages": "static-1.518",
      "customer-data-filters-ui-msw-helpers": "static-1.20920",
      "customer-data-reference-ui-components": "static-1.12824",
      "FormUrlGenerator": "static-2.4418",
      "framework-builder-read-service-client": "static-1.3743",
      "framework-data-schema-quick-fetch": "static-1.6457",
      "inbound-db-meta-service-client": "static-1.3355",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.652",
      "onboarding-tours": "static-1.16116",
      "reporting-datasets-permissions-lib": "static-1.12668",
      "SharedI18nStrings": "static-1.179",
      "ui-addon-teams": "static-1.21075",
      "calling-global-api": "static-1.63266",
      "calling-lifecycle-internal": "static-1.64648",
      "calling-lifecycle-messages": "static-1.56942",
      "commerce-products-lib": "static-1.8511",
      "conditional-properties-service-client": "static-1.3518",
      "external-options-client-types": "static-1.3878",
      "google-libphonenumber": "static-1.31",
      "hs-entities": "static-1.338",
      "inbounddb-objects-service-types": "static-1.3945",
      "meetings-icalendar-utils-lib": "static-1.321",
      "multi-currency-client-types": "static-1.3417",
      "object-builder-ui-client": "static-1.47616",
      "pipeline-validation-client-types": "static-1.3681",
      "property-value-citations": "static-1.1069",
      "pulse": "static-1.173",
      "smart-property-lib": "static-1.5483",
      "tiered-pricing": "static-1.649",
      "ui-addon-form-validation": "static-1.10683",
      "immerable": "static-1.3844",
      "video-components-external": "static-1.10228",
      "video-data-lib": "static-1.33886",
      "audio-components": "static-1.5450",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35717",
      "ui-universal-auth": "static-1.8543",
      "video-components": "static-1.12231",
      "video-embed": "static-1.34720",
      "batch-promise": "static-1.1216",
      "crm-pipelines-api-client-types": "static-1.3860",
      "persist-promise": "static-1.3373",
      "hubspot-apollo-cache": "static-1.27",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24412",
      "knowledge-content-types": "static-1.8266",
      "payment-link-components": "static-1.22623",
      "ui-addon-emoji-picker": "static-1.9577",
      "call-summary": "static-1.37957",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9333",
      "feature-store-service-types": "static-1.4213",
      "merchandise-lib": "static-1.253",
      "purchase-motions-components": "static-1.5316",
      "self-service-api": "static-1.9912",
      "upgrade-management-service-types": "static-1.4204",
      "chatspot-core": "static-1.19886",
      "ContentUtils": "static-1.67260",
      "copilot-toolkit": "static-1.10252",
      "growth-onboarding-feedback-components": "static-1.6273",
      "customer-data-sidebar": "static-2.45131",
      "enrichment-properties-lib": "static-1.14601",
      "customer-data-associations": "static-1.7022",
      "deal-intel-decorators": "static-1.898",
      "reporting-data": "static-1.66017",
      "ui-addon-draggable": "static-3.4432",
      "crm-record-cards-service-types": "static-1.3348",
      "crm_universal": "static-1.21483",
      "SalesContentIndexUI": "static-3.8730",
      "signup-ui-lego-core": "static-1.20195",
      "content-embed-lib": "static-1.7028",
      "data-model-builder-lib": "static-1.11300",
      "remote-ui": "static-1.58",
      "ui-components-test-utils": "static-1.5247",
      "ui-extensions-remote-renderer": "static-1.16132",
      "universal-page-editor-lib": "static-1.2684",
      "integrations-error-boundary-lib": "static-1.12471",
      "laboratory-lib": "static-3.6830",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10061",
      "rxjs": "static-5.10",
      "messaging-types-lib": "static-1.45040",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15870",
      "sequences-client-types-lib": "static-1.7376",
      "foundations-components-test-utils": "static-1.4764",
      "magpie-lib": "static-1.5262",
      "navigation-messaging": "static-1.6273",
      "getting-started-shared-tasks": "static-1.17561",
      "getting-started-shared-tasks-store": "static-1.16679",
      "onboarding-tours-utils": "static-1.182",
      "whatsapp-management-lib": "static-1.7751",
      "growth-data-modal": "static-1.5018",
      "growth-onboarding-confetti": "static-1.2738",
      "growth-onboarding-next-action-utils": "static-1.1182",
      "navigation-components": "static-1.16946",
      "onboarding-tours-client": "static-1.4330",
      "ui-shepherd-tracker": "static-1.7210",
      "shared-worker-versioning": "static-1.10704",
      "calling-orchestration-shared-library": "static-1.34462",
      "products-iframe-lib": "static-1.7050",
      "products-ui-components-shared-msw-handlers": "static-1.9569",
      "directed-graph": "static-1.624",
      "event-emitter": "static-1.612",
      "breeze-intelligence-kit": "static-1.5152",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9270",
      "fsm": "static-1.3418",
      "policy-lib": "static-1.6489",
      "react-tinymce": "static-1.54322",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53448",
      "tinymce-plugins": "static-1.56562",
      "tinymce-themes": "static-1.55418",
      "content-media-composition-data-lib": "static-1.10974",
      "content-media-compositions": "static-2.14981",
      "idb-keyval": "static-1.37",
      "magpie-types": "static-1.4722",
      "media-bridge-lib": "static-1.18388",
      "content-icons-ui": "static-1.2111",
      "social-insights-client-types": "static-1.21075",
      "outpost": "static-1.3902",
      "commerce-analytics-service-client": "static-1.3375",
      "ui-addon-opt": "static-4.8076",
      "commerce-tours-lib": "static-1.5547",
      "growth-onboarding-reliability": "static-1.4775",
      "sales-checkout-service-client": "static-1.3387",
      "ai-addon-copilot-preview": "static-1.7274",
      "calling-cross-tab-library": "static-1.18944",
      "calling-lifecycle-usage-tracker": "static-1.7866",
      "wootric-nps": "static-1.6629",
      "growth-monetization-service-types": "static-1.4220",
      "nav-client-types": "static-1.2019",
      "purchase-motions-api": "static-1.5319",
      "trials-service-types": "static-1.3621",
      "chatspot-client-types": "static-1.10329",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4495",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2738",
      "card-payment-highlight-lib": "static-1.36211",
      "card-subscription-highlight-lib": "static-1.38632",
      "commerce-billing-lib": "static-1.18182",
      "commerce-contract-lib": "static-1.10755",
      "crm_components": "static-3.90876",
      "invoices-highlight-card-lib": "static-1.53653",
      "orders-highlight-card-lib": "static-1.20615",
      "products-highlight-card-lib": "static-1.16795",
      "project-storage": "static-1.4420",
      "quotes-highlight-card-lib": "static-1.70724",
      "usage-based-billing-components-lib": "static-1.7729",
      "deal-intel-utils": "static-1.902",
      "reporting-client-types": "static-1.2355",
      "react-flip-move": "static-1.63",
      "FireAlarmUi": "static-1.4222",
      "sales-templates-service-types-lib": "static-1.3889",
      "ui-asset-management-lib": "static-1.10544",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.9319",
      "collaboration-sidebar": "static-1.56832",
      "conditional-property-settings-modal": "static-1.11706",
      "data-model-commons-lib": "static-1.11655",
      "feedback-loader": "static-1.28658",
      "html-to-image": "static-1.47",
      "object-definition-builder-lib": "static-1.6743",
      "property-management-iframe": "static-1.11875",
      "property-usages-lib": "static-1.5071",
      "reactflow": "static-1.57",
      "simple-data-table": "static-1.1898",
      "used-in-list-lib": "static-1.6598",
      "visual-association": "static-1.5528",
      "highcharts": "static-8.97",
      "reporting-visualizations": "static-1.58094",
      "ui-extensibility-client-types": "static-1.3641",
      "automation-platform-service-types": "static-1.2448",
      "ContentData": "static-1.67335",
      "email-portal-health-service-types": "static-1.663",
      "marketing-email-service-types": "static-1.1741",
      "reactive-lib": "static-1.414",
      "content-whatsapp-service-types": "static-1.199",
      "marketing-platform-lib": "static-1.6517",
      "short-messages-app-service-client": "static-1.3701",
      "ui-tool-access": "static-1.9829",
      "calling-orchestration-schema": "static-1.34687",
      "sales-views-client-types": "static-1.3980",
      "trellis-story-utils": "static-1.4210",
      "storybook-react": "static-1.26",
      "hub-http-contrib": "static-1.2735",
      "interframe": "static-3.4480",
      "tinymce-data": "static-1.39533",
      "ui-addon-sales-email": "static-1.4901",
      "codemirror": "static-5.88",
      "layout-dnd-components": "static-1.11838",
      "layout-dnd-utils": "static-1.10813",
      "react-codemirror": "static-1.10290",
      "ui-brand-identity-lib": "static-1.13396",
      "NamespacedHubStyle": "static-2.8797",
      "hls.js": "static-1.32",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.8968",
      "ai-settings-ui-library": "static-1.7190",
      "chirp-fetch": "static-1.1569",
      "copilot-plugins": "static-1.10225",
      "eligibility-engine-service-types": "static-1.2902",
      "commerce-shared-components-lib": "static-1.17606",
      "commerce-subscription-lib": "static-1.36209",
      "commerce-tools-ui-lib": "static-1.9533",
      "usage-tracker-session-replay": "static-1.4709",
      "utility-belt": "static-1.2229",
      "payments-enrollment-embed-lib": "static-1.21567",
      "quotes-ui-lib": "static-1.79442",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6530",
      "invoices-ui-lib": "static-1.53669",
      "commerce-products-api": "static-1.1785",
      "SafeStorage": "static-1.4091",
      "invoices-iframe-lib": "static-1.55727",
      "quotes-modal-lib": "static-1.101399",
      "platform-infra-nav-components": "static-1.7385",
      "reporting-ui-components": "static-2.63290",
      "subscription-experience-data-types": "static-1.14442",
      "association-translator": "static-1.2879",
      "crm-settings-header-lib": "static-1.7991",
      "settings-ui-nav": "static-2.9837",
      "chatspot-widget-iframe": "static-1.19878",
      "collaboration-sidebar-common": "static-1.1629",
      "crm-properties-common-lib": "static-1.5557",
      "ui-addon-draggable-compat": "static-2.3941",
      "property-management-common": "static-1.4162",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14636",
      "advanced-menus-lib": "static-1.11628",
      "ExportDialog": "static-6.10076",
      "ui-memberships-settings-lib": "static-1.33125",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9138",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.13199",
      "highlight.js": "static-1.72",
      "reporting-action-components": "static-1.40402",
      "ui-addon-react-router-dom": "static-1.9235",
      "growth-onboarding-empty-states": "static-1.5205",
      "InboxConnectUtils": "static-4.13937",
      "payments-post-enroll-local-storage-lib": "static-1.4776",
      "qrcode-generator": "static-1.62",
      "amplitude-session-replay-browser": "static-1.53",
      "marketplace-ui-apps-core": "static-1.17203",
      "stripe-embedded-components": "static-1.6943",
      "products-ui-components": "static-1.39030",
      "totals-ui-components": "static-1.22701",
      "reporting-plugins": "static-1.9840",
      "reporting-reports": "static-1.65696",
      "reporting-snowflake": "static-1.54636",
      "edison-service-client-types": "static-1.78",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14635",
      "simple-menus-lib": "static-1.16152",
      "academy-common-lib": "static-1.12659",
      "dashboard-lib": "static-1.80173",
      "share-with-third-party-component-lib": "static-1.8374",
      "developer-experience-shared-components": "static-1.10137",
      "marketplace-ui-client-types": "static-1.16077",
      "marketplace-ui-common": "static-1.18670",
      "ui-addon-integrations-directory-panel": "static-2.7669",
      "stripe-connect-js": "static-1.62",
      "commerce-permissions": "static-1.440",
      "property-description-translator": "static-1.3546",
      "commerce-totals-service-types": "static-1.3536",
      "campaign-roi-lib": "static-1.7938",
      "academy-service-client": "static-1.3344",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3568",
      "oauth-service-types": "static-1.3928",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.28006",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4393",
      "atom": "/atom/static-1.4759",
      "conversations-async-data": "/conversations-async-data/static-2.7349",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8564",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15652",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12314",
      "conversations-message-history": "/conversations-message-history/static-1.11695",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10184",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.21369",
      "head-dlb": "/head-dlb/static-1.4702",
      "hs-promise-utils": "/hs-promise-utils/static-1.5278",
      "hs-test-utils": "/hs-test-utils/static-1.7667",
      "hubspot-dlb": "/hubspot-dlb/static-2.1773",
      "HubStyleTokens": "/HubStyleTokens/static-2.11109",
      "I18n": "/I18n/static-7.1538",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2704",
      "jasmine-runner": "/jasmine-runner/static-1.6139",
      "quartz": "/quartz/static-1.6568",
      "react-dlb": "/react-dlb/static-1.69",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.58",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4162",
      "StyleGuideUI": "/StyleGuideUI/static-3.481",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.4221",
      "usage-tracker": "/usage-tracker/static-1.7023",
      "usage-tracker-core": "/usage-tracker-core/static-1.6873",
      "usage-tracker-public": "/usage-tracker-public/static-1.6834",
      "viral-links-lib": "/viral-links-lib/static-1.6707",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5814",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4471",
      "conversations-prop-types": "/conversations-prop-types/static-1.7138",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.20106",
      "cssUtils": "/cssUtils/static-1.694",
      "enviro": "/enviro/static-4.371",
      "flux-actions": "/flux-actions/static-1.295",
      "foundations-components": "/foundations-components/static-1.7281",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5872",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9296",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.334",
      "raven": "/raven/static-3.5564",
      "react": "/react/static-7.175",
      "react-aria": "/react-aria/static-1.59",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.65",
      "react-rhumb": "/react-rhumb/static-1.16318",
      "react-utils": "/react-utils/static-2.5072",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.7828",
      "signup-constants": "/signup-constants/static-1.18185",
      "styled-components": "/styled-components/static-2.83",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5437",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5625",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
      "raven-hubspot": "/raven-hubspot/static-1.5871",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3122",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.346",
      "quartz-core": "/quartz-core/static-1.5787",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4517",
      "foundations-theming": "/foundations-theming/static-1.4088",
      "UIComponents": "/UIComponents/static-3.8056",
      "cv-backend-services": "/cv-backend-services/static-1.1446",
      "immutable-less": "/immutable-less/static-1.4341",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6938",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.32067",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2150",
      "customer-data-objects": "/customer-data-objects/static-1.7298",
      "data-fetching-client": "/data-fetching-client/static-1.9361",
      "icons": "/icons/static-2.611",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-router-dom": "/react-router-dom/static-5.26",
      "rpc-client-utils": "/rpc-client-utils/static-1.4291",
      "tanstack-virtual": "/tanstack-virtual/static-1.23",
      "ui-images": "/ui-images/static-2.1056",
      "HeadJS": "/HeadJS/static-2.687",
      "framer-motion": "/framer-motion/static-1.64",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2778",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.145",
      "i18n-data": "/i18n-data/static-1.214",
      "moment-timezone": "/moment-timezone/static-5.76",
      "jasmine": "/jasmine/static-4.4017",
      "history": "/history/static-4.47",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7717",
      "HubStyle": "/HubStyle/static-2.11417",
      "quartz-i18n": "/quartz-i18n/static-1.243",
      "sassPrefix": "/sassPrefix/static-1.149",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3550",
      "floating-ui": "/floating-ui/static-1.49",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1804",
      "hs-story-utils": "/hs-story-utils/static-1.9115",
      "react-virtualized": "/react-virtualized/static-2.92",
      "tanstack-table": "/tanstack-table/static-1.48",
      "trellis-assets": "/trellis-assets/static-1.960",
      "ui-fonts": "/ui-fonts/static-1.371",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3624",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5440",
      "bender-build-tools": "/bender-build-tools/static-1.2798",
      "dispatcher": "/dispatcher/static-1.129",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.767",
      "hubspotter-http": "/hubspotter-http/static-1.4374",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.460",
      "quartz-auth": "/quartz-auth/static-1.243",
      "quartz-head": "/quartz-head/static-1.233",
      "quartz-test": "/quartz-test/static-1.243",
      "usage-tracker-container": "/usage-tracker-container/static-1.7013",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2571",
      "foundations-theming-base": "/foundations-theming-base/static-1.3073",
      "stylex": "/stylex/static-1.25",
      "ts-schema": "/ts-schema/static-1.3800",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
      "avatar-components": "/avatar-components/static-1.2151",
      "content-assistance-lib": "/content-assistance-lib/static-1.7287",
      "crm-component-utils": "/crm-component-utils/static-1.38190",
      "crm-display-components": "/crm-display-components/static-1.23940",
      "crm-fe-perf": "/crm-fe-perf/static-1.22568",
      "crm-links": "/crm-links/static-1.5939",
      "crm-message-bus": "/crm-message-bus/static-1.42060",
      "crm-search-service-types": "/crm-search-service-types/static-1.854",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5018",
      "customer-data-communicator": "/customer-data-communicator/static-1.44596",
      "customer-data-email": "/customer-data-email/static-1.17490",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38486",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12689",
      "customer-data-properties": "/customer-data-properties/static-1.50455",
      "customer-data-rte": "/customer-data-rte/static-1.32206",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9513",
      "draft-plugins": "/draft-plugins/static-2.21111",
      "file-manager-components": "/file-manager-components/static-1.22566",
      "FileManagerCore": "/FileManagerCore/static-1.38065",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6552",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7611",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4568",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17305",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9823",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7778",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17400",
      "universal-associations-select": "/universal-associations-select/static-1.10650",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8062",
      "final-form": "/final-form/static-1.63",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3574",
      "property-translator": "/property-translator/static-1.5100",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.75",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9187",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9185",
      "superstore": "/superstore/static-1.4460",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8408",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27637",
      "card-properties-lib": "/card-properties-lib/static-1.43210",
      "crm-actions": "/crm-actions/static-1.5958",
      "crm-cards-data": "/crm-cards-data/static-1.1050",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42581",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8514",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7755",
      "customer-data-tracking": "/customer-data-tracking/static-1.6548",
      "framework-data-table": "/framework-data-table/static-2.11169",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8202",
      "calling-error-reporting": "/calling-error-reporting/static-1.30982",
      "calling-internal-common": "/calling-internal-common/static-1.30976",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6226",
      "crm_data": "/crm_data/static-4.90876",
      "crm_schema": "/crm_schema/static-3.90915",
      "customer-data-content": "/customer-data-content/static-1.26648",
      "draft-content-plugins": "/draft-content-plugins/static-1.27476",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23463",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23275",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23725",
      "FileManagerLib": "/FileManagerLib/static-1.38206",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17297",
      "integration-settings-components": "/integration-settings-components/static-1.14452",
      "integrations-lib": "/integrations-lib/static-1.15056",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5271",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7474",
      "nav-meta": "/nav-meta/static-1.28583",
      "onboarding-scopes": "/onboarding-scopes/static-1.6130",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5573",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.36811",
      "react-colorpicker": "/react-colorpicker/static-2.9900",
      "react-dnd-compat": "/react-dnd-compat/static-1.4311",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7846",
      "rich-text-lib": "/rich-text-lib/static-1.19271",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3528",
      "sequences-lib": "/sequences-lib/static-1.7519",
      "timezone-utils": "/timezone-utils/static-2.4932",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10813",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8703",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8707",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10033",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9829",
      "user-context": "/user-context/static-1.4781",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4592",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4336",
      "salesImages": "/salesImages/static-1.518",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20920",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12824",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4418",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3743",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6457",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3355",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.652",
      "onboarding-tours": "/onboarding-tours/static-1.16116",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12668",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
      "ui-addon-teams": "/ui-addon-teams/static-1.21075",
      "calling-global-api": "/calling-global-api/static-1.63266",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64648",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56942",
      "commerce-products-lib": "/commerce-products-lib/static-1.8511",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3518",
      "external-options-client-types": "/external-options-client-types/static-1.3878",
      "google-libphonenumber": "/google-libphonenumber/static-1.31",
      "hs-entities": "/hs-entities/static-1.338",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3945",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.321",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3417",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47616",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3681",
      "property-value-citations": "/property-value-citations/static-1.1069",
      "pulse": "/pulse/static-1.173",
      "smart-property-lib": "/smart-property-lib/static-1.5483",
      "tiered-pricing": "/tiered-pricing/static-1.649",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10683",
      "immerable": "/immerable/static-1.3844",
      "video-components-external": "/video-components-external/static-1.10228",
      "video-data-lib": "/video-data-lib/static-1.33886",
      "audio-components": "/audio-components/static-1.5450",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35717",
      "ui-universal-auth": "/ui-universal-auth/static-1.8543",
      "video-components": "/video-components/static-1.12231",
      "video-embed": "/video-embed/static-1.34720",
      "batch-promise": "/batch-promise/static-1.1216",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3860",
      "persist-promise": "/persist-promise/static-1.3373",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.27",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24412",
      "knowledge-content-types": "/knowledge-content-types/static-1.8266",
      "payment-link-components": "/payment-link-components/static-1.22623",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9577",
      "call-summary": "/call-summary/static-1.37957",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9333",
      "feature-store-service-types": "/feature-store-service-types/static-1.4213",
      "merchandise-lib": "/merchandise-lib/static-1.253",
      "purchase-motions-components": "/purchase-motions-components/static-1.5316",
      "self-service-api": "/self-service-api/static-1.9912",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4204",
      "chatspot-core": "/chatspot-core/static-1.19886",
      "ContentUtils": "/ContentUtils/static-1.67260",
      "copilot-toolkit": "/copilot-toolkit/static-1.10252",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6273",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45131",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14601",
      "customer-data-associations": "/customer-data-associations/static-1.7022",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.898",
      "reporting-data": "/reporting-data/static-1.66017",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4432",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3348",
      "crm_universal": "/crm_universal/static-1.21483",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8730",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20195",
      "content-embed-lib": "/content-embed-lib/static-1.7028",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.11300",
      "remote-ui": "/remote-ui/static-1.58",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5247",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16132",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2684",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12471",
      "laboratory-lib": "/laboratory-lib/static-3.6830",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10061",
      "rxjs": "/rxjs/static-5.10",
      "messaging-types-lib": "/messaging-types-lib/static-1.45040",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15870",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7376",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4764",
      "magpie-lib": "/magpie-lib/static-1.5262",
      "navigation-messaging": "/navigation-messaging/static-1.6273",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17561",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16679",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.182",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.7751",
      "growth-data-modal": "/growth-data-modal/static-1.5018",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2738",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1182",
      "navigation-components": "/navigation-components/static-1.16946",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4330",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7210",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10704",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34462",
      "products-iframe-lib": "/products-iframe-lib/static-1.7050",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9569",
      "directed-graph": "/directed-graph/static-1.624",
      "event-emitter": "/event-emitter/static-1.612",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5152",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9270",
      "fsm": "/fsm/static-1.3418",
      "policy-lib": "/policy-lib/static-1.6489",
      "react-tinymce": "/react-tinymce/static-1.54322",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53448",
      "tinymce-plugins": "/tinymce-plugins/static-1.56562",
      "tinymce-themes": "/tinymce-themes/static-1.55418",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10974",
      "content-media-compositions": "/content-media-compositions/static-2.14981",
      "idb-keyval": "/idb-keyval/static-1.37",
      "magpie-types": "/magpie-types/static-1.4722",
      "media-bridge-lib": "/media-bridge-lib/static-1.18388",
      "content-icons-ui": "/content-icons-ui/static-1.2111",
      "social-insights-client-types": "/social-insights-client-types/static-1.21075",
      "outpost": "/outpost/static-1.3902",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3375",
      "ui-addon-opt": "/ui-addon-opt/static-4.8076",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5547",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4775",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3387",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7274",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18944",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.7866",
      "wootric-nps": "/wootric-nps/static-1.6629",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4220",
      "nav-client-types": "/nav-client-types/static-1.2019",
      "purchase-motions-api": "/purchase-motions-api/static-1.5319",
      "trials-service-types": "/trials-service-types/static-1.3621",
      "chatspot-client-types": "/chatspot-client-types/static-1.10329",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4495",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2738",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36211",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38632",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18182",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10755",
      "crm_components": "/crm_components/static-3.90876",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53653",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20615",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16795",
      "project-storage": "/project-storage/static-1.4420",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.70724",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7729",
      "deal-intel-utils": "/deal-intel-utils/static-1.902",
      "reporting-client-types": "/reporting-client-types/static-1.2355",
      "react-flip-move": "/react-flip-move/static-1.63",
      "FireAlarmUi": "/FireAlarmUi/static-1.4222",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3889",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10544",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.9319",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56832",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.11706",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11655",
      "feedback-loader": "/feedback-loader/static-1.28658",
      "html-to-image": "/html-to-image/static-1.47",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6743",
      "property-management-iframe": "/property-management-iframe/static-1.11875",
      "property-usages-lib": "/property-usages-lib/static-1.5071",
      "reactflow": "/reactflow/static-1.57",
      "simple-data-table": "/simple-data-table/static-1.1898",
      "used-in-list-lib": "/used-in-list-lib/static-1.6598",
      "visual-association": "/visual-association/static-1.5528",
      "highcharts": "/highcharts/static-8.97",
      "reporting-visualizations": "/reporting-visualizations/static-1.58094",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3641",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2448",
      "ContentData": "/ContentData/static-1.67335",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.663",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1741",
      "reactive-lib": "/reactive-lib/static-1.414",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.199",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6517",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3701",
      "ui-tool-access": "/ui-tool-access/static-1.9829",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34687",
      "sales-views-client-types": "/sales-views-client-types/static-1.3980",
      "trellis-story-utils": "/trellis-story-utils/static-1.4210",
      "storybook-react": "/storybook-react/static-1.26",
      "hub-http-contrib": "/hub-http-contrib/static-1.2735",
      "interframe": "/interframe/static-3.4480",
      "tinymce-data": "/tinymce-data/static-1.39533",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4901",
      "codemirror": "/codemirror/static-5.88",
      "layout-dnd-components": "/layout-dnd-components/static-1.11838",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10813",
      "react-codemirror": "/react-codemirror/static-1.10290",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13396",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8797",
      "hls.js": "/hls.js/static-1.32",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.8968",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7190",
      "chirp-fetch": "/chirp-fetch/static-1.1569",
      "copilot-plugins": "/copilot-plugins/static-1.10225",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2902",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17606",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36209",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9533",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4709",
      "utility-belt": "/utility-belt/static-1.2229",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21567",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79442",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6530",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53669",
      "commerce-products-api": "/commerce-products-api/static-1.1785",
      "SafeStorage": "/SafeStorage/static-1.4091",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55727",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.101399",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7385",
      "reporting-ui-components": "/reporting-ui-components/static-2.63290",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14442",
      "association-translator": "/association-translator/static-1.2879",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7991",
      "settings-ui-nav": "/settings-ui-nav/static-2.9837",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.19878",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1629",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5557",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3941",
      "property-management-common": "/property-management-common/static-1.4162",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14636",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11628",
      "ExportDialog": "/ExportDialog/static-6.10076",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33125",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9138",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.13199",
      "highlight.js": "/highlight.js/static-1.72",
      "reporting-action-components": "/reporting-action-components/static-1.40402",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9235",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5205",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13937",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4776",
      "qrcode-generator": "/qrcode-generator/static-1.62",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17203",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6943",
      "products-ui-components": "/products-ui-components/static-1.39030",
      "totals-ui-components": "/totals-ui-components/static-1.22701",
      "reporting-plugins": "/reporting-plugins/static-1.9840",
      "reporting-reports": "/reporting-reports/static-1.65696",
      "reporting-snowflake": "/reporting-snowflake/static-1.54636",
      "edison-service-client-types": "/edison-service-client-types/static-1.78",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14635",
      "simple-menus-lib": "/simple-menus-lib/static-1.16152",
      "academy-common-lib": "/academy-common-lib/static-1.12659",
      "dashboard-lib": "/dashboard-lib/static-1.80173",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8374",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10137",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16077",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18670",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7669",
      "stripe-connect-js": "/stripe-connect-js/static-1.62",
      "commerce-permissions": "/commerce-permissions/static-1.440",
      "property-description-translator": "/property-description-translator/static-1.3546",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3536",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7938",
      "academy-service-client": "/academy-service-client/static-1.3344",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3568",
      "oauth-service-types": "/oauth-service-types/static-1.3928",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};